import React from 'react';

import cn from 'libs/cn';

interface OptionDisplayProps {
  title: string;
  pretitle?: string | null;
  subtitle?: React.ReactNode | null;
  className?: string;
}

const OptionDisplay = ({
  title,
  pretitle,
  subtitle,
  className,
  children,
}: React.PropsWithChildren<OptionDisplayProps>) => (
  <div className={cn('flex flex-col', className)}>
    {pretitle && (
      <p className="text-sand-1000 body-xxs dark:text-dark-1000">{pretitle}</p>
    )}
    <p className="text-sand-1200 body-xs dark:text-dark-1200">{title}</p>
    {typeof subtitle === 'string' ? (
      <p className="text-sand-1000 body-xxs dark:text-dark-1000">{subtitle}</p>
    ) : (
      subtitle
    )}
    {children}
  </div>
);

export default OptionDisplay;
